<div class="container-fluid vh-100 d-flex flex-column p-4" style="background-color: white">
  <div
    style="position: sticky; top: 0; background-color: white; z-index: 1000; padding: 16px; border-bottom: 1px solid #ddd"
  >
    <h5 class="text-black fw-bold mb-2">Edit–Reinitiate NeSL Signers</h5>
    <p class="text-muted mb-0">
      Only the name and DOI/DOB of signers whose eSign was not affixed can be
      changed. Completed signers and identity fields are preserved.
    </p>
  </div>

  <div style="flex: 1; overflow-y: auto; padding: 16px">
    <form [formGroup]="signerForm">
      <div formArrayName="signers">
        <div
          *ngFor="let signer of signers.controls; let i = index"
          [formGroupName]="i"
          class="card p-3 mb-4 shadow-sm"
          style="background-color: #f9f9f9"
        >
          <h5 class="text-black mb-3">
            Signatory {{ signer.get('signatory_sequence')?.value }}
          </h5>

          <div class="row g-3">
            <div class="col-lg-4 col-md-6">
              <label class="form-label">
                Signatory Name <span class="text-danger">*</span>
              </label>
              <input
                class="form-control"
                formControlName="name"
                placeholder="Enter name"
                maxlength="255"
                type="text"
                (input)="onChange(i)"
              />
              <span
                class="text-danger"
                *ngIf="signer.get('name')?.invalid && signer.get('name')?.touched"
              >
                Enter a valid signatory name
              </span>
            </div>

            <div class="col-lg-4 col-md-6">
              <label class="form-label">
                DOI/DOB <span class="text-danger">*</span>
              </label>
              <input
                class="form-control"
                formControlName="DOI"
                type="date"
                (input)="onChange(i)"
              />
              <span
                class="text-danger"
                *ngIf="signer.get('DOI')?.invalid && signer.get('DOI')?.touched"
              >
                DOI/DOB is required
              </span>
            </div>

            <div class="col-lg-4 col-md-6">
              <label class="form-label">Status</label>
              <input class="form-control" formControlName="status" type="text" />
            </div>
          </div>

          <div class="row g-3 mt-2">
            <div class="col-lg-4 col-md-6">
              <label class="form-label">Email</label>
              <input class="form-control" formControlName="email" type="email" />
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="form-label">Mobile</label>
              <input class="form-control" formControlName="contact_number" type="text" />
            </div>
            <div class="col-lg-4 col-md-6">
              <label class="form-label">Contract Relation</label>
              <input class="form-control" formControlName="CONTRACT_RELATION" type="text" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div
    style="position: sticky; bottom: 0; background-color: white; z-index: 1000; padding: 16px; border-top: 1px solid #ddd"
  >
    <div class="d-flex justify-content-end">
      <button
        type="button"
        class="btn"
        [disabled]="signerForm.invalid || !referenceId || isSubmitting"
        (click)="retrigger()"
        style="background-color: #612e86; color: white; border: none; padding: 8px 16px; border-radius: 4px; margin-right: 16px"
      >
        {{ isSubmitting ? 'Reinitiating...' : 'Confirm Reinitiate' }}
      </button>
      <button
        type="button"
        class="btn"
        [disabled]="isSubmitting"
        (click)="onCancel()"
        style="background-color: #612e86; color: white; border: none; padding: 8px 16px; border-radius: 4px"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
